<template>
  <b-tooltip
    :label="$t('compScenarioAdminUserMenu.tooltip')"
    type="is-black"
    position="is-right"
    multilined
    :active="!(adminStore.allGHGI.length > 0)"
    style="width: 100%"
  >
    <b-menu-item
      :active="buffer === 'all-scenarios'"
      :expanded="buffer === 'all-scenarios'"
      :disabled="!(adminStore.allGHGI.length > 0)"
      @click="activate('all-scenarios')"
    >
      <template slot="label" slot-scope="props">
        <b-icon icon="crosshairs"></b-icon>
        {{ $t('scenario') }}
        <b-icon
          class="is-pulled-right"
          :icon="props.expanded ? 'caret-down' : 'caret-up'"
        >
        </b-icon>
      </template>
      <b-menu-item
        :active="buffer === 'all-scenarios'"
        @click="activate('all-scenarios')"
        :disabled="!(adminStore.allGHGI.length > 0)"
      >
        <template slot="label">
          <b-icon icon="crosshairs"></b-icon>
          {{ $t('compScenarioAdminUserMenu.scenarios') }}
        </template>
      </b-menu-item>
    </b-menu-item>
  </b-tooltip>
</template>

<script>
import { useAdminStore } from '@/stores/admin.js'

export default {
  name: 'UserMenu',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  setup () {
    const adminStore = useAdminStore()
    return { adminStore }
  },
  data () {
    return {
      buffer: this.value
    }
  },
  watch: {
    value: function () {
      this.buffer = this.value
    }
  },
  methods: {
    activate: function (val) {
      this.buffer = val
      this.$emit('input', this.buffer)
    }
  }
}
</script>
